// ============================================================
//  XPDC COMING SOON — GLOBAL CONFIG
//  Ubah tanggal peluncuran di sini kapan saja.
//  Format: tahun, bulan (0 = Januari, 6 = Juli), tanggal, jam, menit
// ============================================================

// Tanggal peluncuran resmi: 21 Juli 2026, 00:00 WIB (UTC+7)
export const LAUNCH_DATE = new Date("2026-07-21T00:00:00+07:00");

// URL tujuan
export const NEW_SITE_URL = "https://xpdc.co.id";
export const OLD_SITE_URL = "https://xpdcargo.id";

// Info domain
export const OLD_DOMAIN = "xpdcargo.id";
export const NEW_DOMAIN = "xpdc.co.id";

// Brand assets (dilayani secara lokal dari /public/assets — self-contained)
const A = (process.env.PUBLIC_URL || "") + "/assets";
export const ASSETS = {
  newLogoText: `${A}/new-logo-text.webp`,
  newLogoIcon: `${A}/new-logo-icon.png`,
  oldLogoText: `${A}/old-logo-text.webp`,
  oldLogoIcon: `${A}/old-logo-icon.png`,
  newSiteShot: `${A}/new-site.png`,
  oldSiteShot: `${A}/old-site.png`,
};
